import { render, staticRenderFns } from "./OverlayFrame.vue?vue&type=template&id=76944424&scoped=true&"
import script from "./OverlayFrame.vue?vue&type=script&lang=js&"
export * from "./OverlayFrame.vue?vue&type=script&lang=js&"
import style0 from "./OverlayFrame.vue?vue&type=style&index=0&id=76944424&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76944424",
  null
  
)

export default component.exports